import React from 'react';

export const Complaints = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 0.895429 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V8.16485C18 16.2341 11.1289 19.2682 9.64525 19.8317L9.29019 18.8968L9.64524 19.8317C9.22629 19.9908 8.77371 19.9908 8.35476 19.8317L8.70981 18.8968L8.35475 19.8317C6.87108 19.2682 0 16.2341 0 8.16485V2ZM16 2L2 2V8.16485C2 14.7589 7.50927 17.3573 9 17.9371C10.4907 17.3573 16 14.7589 16 8.16485V2ZM10.5 6C10.5 6.82843 9.82843 7.5 9 7.5C8.17157 7.5 7.5 6.82843 7.5 6C7.5 5.17157 8.17157 4.5 9 4.5C9.82843 4.5 10.5 5.17157 10.5 6ZM10 10C10 9.44771 9.55229 9 9 9C8.44771 9 8 9.44771 8 10V14C8 14.5523 8.44771 15 9 15C9.55229 15 10 14.5523 10 14V10Z"
        fill="white"
      />
    </svg>
  );
};
